import { render, staticRenderFns } from "./ItemSkuBox.vue?vue&type=template&id=0867c0a5&scoped=true&"
import script from "./ItemSkuBox.vue?vue&type=script&lang=js&"
export * from "./ItemSkuBox.vue?vue&type=script&lang=js&"
import style0 from "./ItemSkuBox.vue?vue&type=style&index=0&id=0867c0a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867c0a5",
  null
  
)

export default component.exports